import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { configureDatamodel } from '@w3booster/datamodel';

configureDatamodel(environment.PARSE);

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function() {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err: any) => {
    console.error('W3Booster client bootstrap failed.', err);
    if (document?.body && !document.getElementById('w3-bootstrap-error')) {
      const panel = document.createElement('pre');
      panel.id = 'w3-bootstrap-error';
      panel.setAttribute('style', 'position:fixed;z-index:2147483647;left:24px;right:24px;bottom:24px;max-height:42vh;overflow:auto;padding:16px 18px;border:1px solid #9f4f47;border-left:4px solid #dc6a5c;border-radius:5px;background:#171113;color:#f0dcda;font:12px/1.45 Consolas,monospace;box-shadow:0 16px 50px #000;white-space:pre-wrap');
      panel.textContent = 'W3Booster could not start\n\nPlease close W3Booster and start it again. If the problem continues, contact W3Booster support.';
      document.body.appendChild(panel);
    }
  });
